<template>
    <label for="show-bar-count">
        <input id="show-bar-count" @change="emitInput" type="checkbox" name="show-bar-count" v-model="value" class="mr-1" />
        Show Bar Count
    </label>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    defaultValue: Boolean
});
const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function emitInput() {
    emit('update:modelValue', value.value);
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
});
</script>
